import React, { useEffect, useState } from "react";

/**
 * Renders a HubSpot form inside an isolated, same-origin iframe so the embed
 * does not inherit app/Tailwind background styles. The wrapper reports height
 * so the iframe auto-resizes.
 */
const HubSpotFormEmbed = ({ src, title, initialHeight = 720 }) => {
  const [height, setHeight] = useState(initialHeight);

  useEffect(() => {
    const onMessage = (event) => {
      const data = event.data;
      if (
        data &&
        data.type === "hs-form-height" &&
        typeof data.height === "number" &&
        data.height > 0
      ) {
        setHeight(data.height);
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return (
    <iframe
      title={title}
      src={src}
      scrolling="no"
      style={{
        width: "100%",
        height,
        border: "none",
        background: "transparent",
        colorScheme: "normal",
      }}
    />
  );
};

export default HubSpotFormEmbed;
